import { apiGet, apiPost } from './apiClient';

export const getPushStats = async () => {
  return apiGet('notifications/push/stats');
};

/**
 * Mobil Expo — eski (legacy) veya yeni (new) app
 * @param {{ title: string, body: string, app?: 'legacy'|'new', audience?: 'all'|'users', userIds?: string[] }} payload
 */
export const sendPushNotification = async (payload) => {
  return apiPost('notifications/push/send', {
    title: payload.title,
    body: payload.body,
    channel: 'mobile',
    app: payload.app || 'legacy',
    audience: payload.audience || 'all',
    ...(payload.userIds?.length ? { userIds: payload.userIds } : {}),
  });
};

/**
 * Web only — login olmus herkese / rol / user
 * @param {{ title: string, body: string, eventId?: string, audience?: 'all'|'users'|'role'|'live', userIds?: string[], crole?: string }} payload
 */
export const sendWebNotification = async (payload) => {
  return apiPost('notifications/web/send', {
    title: payload.title,
    body: payload.body,
    audience: payload.audience || 'all',
    ...(payload.eventId ? { eventId: payload.eventId } : {}),
    ...(payload.userIds?.length ? { userIds: payload.userIds } : {}),
    ...(payload.crole ? { crole: payload.crole } : {}),
  });
};

/** Web hedef — tum user arama */
export const searchUsersForNotify = async (q) => {
  const query = encodeURIComponent((q || '').trim());
  if (!query) return [];
  const res = await apiGet(`users?q=${query}&perPage=20&page=1`);
  return Array.isArray(res?.data) ? res.data : Array.isArray(res) ? res : [];
};

export const searchLegacyPushUsers = async (q) => {
  const query = encodeURIComponent((q || '').trim());
  if (!query) return [];
  const res = await apiGet(`notifications/push/legacy-users?q=${query}`);
  return Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
};

/** Yeni mobil — sadece token sahibi (fallback yok) */
export const searchNewPushUsers = async (q) => {
  const query = encodeURIComponent((q || '').trim());
  if (!query) return [];
  const res = await apiGet(`notifications/push/new-users?q=${query}`);
  return Array.isArray(res) ? res : Array.isArray(res?.data) ? res.data : [];
};
